export const config = {
 bucketName: "classyyapp",
 dirName: "bannerImages",
 region: "ap-south-1",
 accessKeyId: process.env.REACT_APP_ACCESSKEYID ? process.env.REACT_APP_ACCESSKEYID : "",
 secretAccessKey: process.env.REACT_APP_SECRETKEY ? process.env.REACT_APP_SECRETKEY : "",
};
